// Regras de preenchimento da ficha cadastral.
// Espelham as do back (routes/dashboard.js: CAMPOS_FICHA, CAMPOS_SOCIO e progressoFicha) — mantenha as duas iguais.

export const ESTADOS_BRASIL = [
    "Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal", "Espírito Santo", "Goiás",
    "Maranhão", "Mato Grosso", "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba", "Paraná", "Pernambuco",
    "Piauí", "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul", "Rondônia", "Roraima", "Santa Catarina",
    "São Paulo", "Sergipe", "Tocantins",
];

export const ESTADOS_CIVIS = ["Solteiro(a)", "Casado(a)", "Divorciado(a)", "Separado(a)", "Viúvo(a)"];
export const REGIMES_BENS = ["Comunhão parcial de bens", "Comunhão universal de bens", "Separação total de bens", "Participação final nos aquestos"];

export const DOCUMENTOS_SOCIO = [
    { tipo: "rgCnh", nome: "RG ou CNH", descricao: "Frente e verso, legível e dentro da validade." },
    { tipo: "tituloEleitor", nome: "Título de eleitor", descricao: "Físico ou digital (e-Título)." },
    { tipo: "comprovanteResidencia", nome: "Comprovante de residência", descricao: "Emitido nos últimos 90 dias." },
];

export const CAMPOS_FICHA = [
    { campo: "razaoSocial", nome: "Razão social" },
    { campo: "nomeFantasia", nome: "Nome fantasia" },
    { campo: "enderecoEmpresa", nome: "Endereço da empresa" },
    { campo: "capitalSocial", nome: "Capital social" },
    { campo: "atividades", nome: "Atividades da empresa" },
];

export const CAMPOS_SOCIO = [
    { campo: "nome", nome: "Nome" },
    { campo: "cpf", nome: "CPF" },
    { campo: "dataNascimento", nome: "Data de nascimento" },
    { campo: "rg", nome: "RG" },
    { campo: "orgaoRg", nome: "Órgão emissor do RG" },
    { campo: "email", nome: "E-mail" },
    { campo: "telefone", nome: "Telefone" },
    { campo: "endereco", nome: "Endereço" },
    { campo: "estadoCivil", nome: "Estado civil" },
    { campo: "percentual", nome: "Participação" },
];

export const campoPreenchido = (valor) =>
    Array.isArray(valor) ? valor.length > 0 : valor !== null && valor !== undefined && String(valor).trim() !== "";

export const camposPendentesFicha = (ficha) => CAMPOS_FICHA.filter((c) => !campoPreenchido(ficha?.[c.campo]));

export const camposPendentesSocio = (socio) => [
    ...CAMPOS_SOCIO,
    ...(socio?.estadoCivil === "Casado(a)" ? [{ campo: "regimeBens", nome: "Regime de bens" }] : []),
].filter((c) => !campoPreenchido(socio?.[c.campo]));

export const somaParticipacoes = (socios) =>
    Math.round(socios.reduce((soma, s) => soma + (Number(s.percentual) || 0), 0) * 100) / 100;

// Empresa vale 40%, dados dos sócios 40% e participações somando 100% os outros 20%
export const progressoFicha = (ficha, socios) => {
    const empresa = ficha ? (CAMPOS_FICHA.length - camposPendentesFicha(ficha).length) / CAMPOS_FICHA.length : 0;
    const completos = socios.filter((s) => camposPendentesSocio(s).length === 0).length;
    return Math.round(
        empresa * 40
        + (socios.length ? (completos / socios.length) * 40 : 0)
        + (socios.length && somaParticipacoes(socios) === 100 ? 20 : 0)
    );
};

// Status gravados pelo back/admin
export const statusDocumento = (documentos, tipo) => {
    const status = documentos?.[`${tipo}Status`];
    if (status === "Válido") return "Válido";
    if (status === "Em Análise") return "Em Análise";
    if (status === "Rejeitado" || status === "Reprovado") return "Rejeitado";
    return "Pendente";
};

export const documentosAprovados = (socio) =>
    DOCUMENTOS_SOCIO.every((d) => statusDocumento(socio.documentos, d.tipo) === "Válido");

export const formatarPercentual = (valor) =>
    `${Number(valor || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;
